export const enUS = {
    ACCOUNT: {
        HEADER: {
            IMG_ALT: 'Sound waves graphic',
        },
        MODALS: {
            CHANGE_AVATAR_IMAGE: {
                BUTTONS: {
                    CANCEL: 'Cancel',
                    REMOVE_IMAGE: 'Remove Image',
                },
                CTA: {
                    PART_1: 'Drag and drop an image (.jpg, .jpeg or .png) here or',
                    PART_2: 'browse your computer.',
                },
                DROPZONE: 'Drop image to upload',
                TITLE: 'Profile Picture',
            },
            CHANGE_PASSWORD: {
                BUTTONS: {
                    CANCEL: 'Cancel',
                    UPDATE_PASSWORD: 'Update Password',
                },
                INPUTS: {
                    CONFIRM_PASSWORD: 'Confirm Password',
                    CURRENT_PASSWORD: 'Current Password',
                    NEW_PASSWORD: 'New Password',
                },
                TITLE: 'Change Password',
                WARNINGS: {
                    DUPLICATE_PASSWORD:
                        'Your new password must be different than your current password.',
                    INVALID_PASSWORD: 'Please enter a valid password.',
                    MISMATCHED_PASSWORD: 'Your passwords must match.',
                },
            },
            CONFIRM_DELETE_ENTITY: {
                BUTTONS: {
                    CANCEL: 'Cancel',
                    DELETE_ENTITY: 'Delete Entity',
                },
                PART_1: 'Your account has',
                PART_2: 'entities remaining; you may delete this one and add statements for new entities up to your account limit.',
                PART_3: 'If you want to use this entity in the future, you will have to upload a statement from this entity again.',
            },
        },
        SECTIONS: {
            ENTITY_MANAGER: {
                CTA: {
                    ENTITY_SELECTOR: 'Entity Selector',
                    PART_1: 'To add an entity,',
                    PART_2: 'from that entity.',
                    PART_3: 'All entities with uploaded statements will appear in the',
                    PART_4: 'at the top right of many pages.',
                    UPLOAD_A_STATEMENT: 'upload a statement',
                },
                ENTITY_SELECTOR_TOOLTIP: {
                    BODY: 'The Entity Selector allows you to explore data as the owner of one of your statements.',
                    IMG_ALT: 'Image of Entity Selector',
                    TITLE: 'Entity Selector',
                },
                TITLE: 'Entity Manager',
            },
            INVITE_OTHERS: {
                BUTTONS: {
                    SEND_INVITE: 'Send Invite',
                },
                CTA: {
                    INVITE: 'invite',
                    INVITES: 'invites',
                    PART_1: 'You have',
                    PART_2: 'left!',
                    PART_3: 'Invite other',
                    PART_4: 'writers or publishers',
                    PART_5: 'to join you on Trqk!',
                },
                INPUT_PLACEHOLDER: 'Email',
                INVITES_SENT: 'Invites sent:',
                TITLE: 'Invite Others',
            },
            NOTIFICATIONS: {
                DETECTIONS: {
                    DESCRIPTION:
                        'Receive an email with a summary of your latest detections if they are reported.',
                    ENABLE: 'Enable',
                    PERIOD_DESCRIPTION: 'Frequency',
                    PERIOD_LABELS: {
                        DAILY: 'Daily',
                        WEEKLY: 'Weekly',
                    },
                    TITLE: 'Detections',
                },
                TITLE: 'Notifications',
            },
            PAYMENT_PLAN: {
                AVAILABLE: 'Available',
                CHOOSE_PLAN: {
                    FEATURES: 'Features',
                    FREE: 'Free',
                    TOP: 'Top',
                    UP_TO: 'Up to',
                    WE_RECOMMEND:
                        'Based on your most recent royalties and detections, we recommend this plan.',
                },
                CONTACT_US_TO_UPGRADE: {
                    DESCRIPTION: {
                        PART_1: 'It looks like your needs may exceed our standard plan offerings. Please email us at',
                        PART_2: 'and we’ll set you up with a plan that works for you.',
                    },
                    EMAIL_CONTENT: {
                        BODY_PART_1:
                            'I need help with setting up my payment plan. My Trqk user ID is:',
                        BODY_PART_2:
                            '[Enter any details you can provide here.]',
                        GREETING: 'Hello,',
                        SIGN_OFF: 'Thanks!',
                        SUBJECT: 'Help with setting up payment plan',
                    },
                    TITLE: 'Need more? Contact us to upgrade.',
                },
                CURRENT_PLAN: 'Current Plan',
                EXCESS_USAGE: {
                    OUTGROWN_PLAN:
                        'Your royalty or detection usage has outgrown your current payment plan.',
                    SELECT_RECOMMENDED_PLAN:
                        'Please select the recommended plan or contact us to continue using TrqkIQ™.',
                },
                FEATURE_LISTS: {
                    BASIC_TO_PRO: [
                        'Royalty Insights',
                        'Performance Detections',
                    ],
                    PUBLISHER_EDITION: [
                        'Unlimited royalty capacity',
                        'Gap Analysis Reporting with bulk detection upload*',
                        'More billing options, including invoicing, with payment terms tailored to fit your needs',
                    ],
                    SCALE: ['Royalty Insights', 'Performance Detections'],
                },
                FEES_BASED_ON:
                    'Fees are based on your most recently quarterly royalties and number of detection tracks.',
                IN_QUARTERLY_ROYALTIES: 'in quarterly royalties',
                LINKS: {
                    CHOOSE_PLAN: 'Choose Plan',
                    DOWNGRADE: 'Downgrade',
                    MANAGE_PLAN: 'Manage Plan',
                    PAYMENT_SETTINGS: 'Payment Settings',
                    SELECT_PLAN: 'Select Plan',
                    UPDATE_PLAN: 'Update Plan',
                    UPGRADE: 'Upgrade',
                },
                NEED_DETECTIONS: {
                    BODY: 'The Pro Plan will help you discover when and where your music is played across a multitude of sources.',
                    TITLE: 'Upgrade to the Pro Plan for Detections!',
                    TRIGGER: 'Need detections?',
                },
                NONE: 'None',
                PER_QUARTER: '/ quarter',
                PLAN_DISPLAY_NAMES: {
                    CHARGEBEE_PLAN_BASIC: 'Basic',
                    CHARGEBEE_PLAN_CATALOG_ANALYSIS: 'Catalog Analysis',
                    CHARGEBEE_PLAN_LITE: 'Lite',
                    CHARGEBEE_PLAN_NEW_BASIC: 'Basic',
                    CHARGEBEE_PLAN_NEW_PRO: 'Pro',
                    CHARGEBEE_PLAN_PRO: 'Pro',
                    CHARGEBEE_PLAN_PUBLISHER: 'Publisher Edition',
                    CHARGEBEE_PLAN_RISE: 'Rise',
                    CHARGEBEE_PLAN_SCALE: 'Scale',
                    CHARGEBEE_PLAN_TRIAL: 'Free Trial',
                },
                PUBLISHER_EDITION_PLAN: {
                    CONTACT_SUPPORT: 'Contact Support',
                    CONTACT_US: 'Contact Us',
                    DESCRIPTION:
                        'Contact us to learn how we can support your publishing company or library.',
                    SET_UP_PLAN_EMAIL_CONTENT: {
                        BODY_PART_1:
                            'I’m interested in setting up a Publisher Edition plan with Trqk. My Trqk user ID is:',
                        BODY_PART_2: '[Enter any other details here.]',
                        GREETING: 'Hello,',
                        SIGN_OFF: 'Thanks!',
                        SUBJECT: 'Interested in Publisher Edition plan',
                    },
                    SUPPORT_EMAIL_CONTENT: {
                        BODY_PART_1:
                            'I need help with my Publisher Edition plan. My Trqk user ID is:',
                        BODY_PART_2: '[Enter any other details here.]',
                        GREETING: 'Hello,',
                        SIGN_OFF: 'Thanks!',
                        SUBJECT: 'Help with Publisher Edition plan',
                    },
                },
                QRR_OVERAGE: {
                    ALERTS_TAB: 'Alerts tab',
                    BY_A_MARGIN_OF: 'by a margin of',
                    EXCEEDED_CAPACITY_OF: 'exceeded your royalty capacity of',
                    INCREASE_CAPACITY_HERE:
                        'To continue uploading statements, click Manage Plan and select a plan with more royalty capacity. You may also contact us to set up a publisher plan.',
                    OF_THE_STATEMENT_MANAGER: 'of the statement manager.',
                    SEE_MORE_DETAILS: 'More details are available in the',
                    YOUR_RECENT_UPLOAD: 'Your recent upload with file name',
                },
                SETTINGS: {
                    DETECTION_TRACKS: 'Detection Tracks',
                    GAP_ANALYSIS_REPORTS: {
                        FROM_EXTERNAL_DATA: 'Detections from imported data',
                        FROM_TRQK_DATA: 'Detections from Trqk data',
                        TITLE: 'Gap Analysis Reports',
                    },
                    QUARTERLY_ROYALTIES: 'Quarterly Royalties',
                },
                TITLE: 'Payment Plan',
                TOASTS: {
                    PAYMENT_PLAN_IS_BEING_UPDATED:
                        'Your payment plan is being updated . . .',
                    PAYMENT_PLAN_UPDATED: 'Your payment plan has been updated.',
                    PROBLEM_DURING_CHECKOUT:
                        'There was a problem during checkout.',
                    PROBLEM_OPENING_CHECKOUT:
                        'There was a problem when opening checkout.',
                },
                TOOLTIPS: {
                    CAPACITY_REQUIREMENTS: {
                        CONTACT_US_AT: 'Contact us at',
                        EMAIL_CONTENT: {
                            BODY_PART_1:
                                'I need help with adjusting my royalty or detection usage to match my payment plan. My Trqk user ID is:',
                            BODY_PART_2:
                                '[Enter any details you can provide here.]',
                            GREETING: 'Hello,',
                            SIGN_OFF: 'Thanks!',
                            SUBJECT:
                                'Help with adjusting royalty/detection usage',
                        },
                        FOR_ASSISTANCE: 'for assistance.',
                        MUST_PURCHASE_ENOUGH_CAPACITY:
                            'You must purchase enough royalty and detection capacity to cover your current usage.',
                        NEED_HELP: 'Need help adjusting your usage?',
                        NOT_ELIGIBLE_FOR_BASIC_PLAN:
                            'To be eligible for a basic plan, your royalty usage must be below',
                    },
                },
                UNLIMITED: 'Unlimited',
                USED: 'Used',
                VIEW_CALCULATION: 'View Calculation',
                YOUR_PLAN: 'YOUR PLAN',
            },
            PROFILE: {
                BUTTONS: {
                    CHANGE_PASSWORD: 'Change Password',
                },
                INPUTS: {
                    COMPANY: 'Company',
                    EMAIL: 'Email',
                    NAME: 'Name',
                    PASSWORD: 'Password',
                },
                TITLE: 'Profile',
            },
        },
        TOASTS: {
            CHANGE_PASSWORD_ERROR_GENERAL:
                'There was a problem with your password change request. Please try again using a different new password.',
            CHANGE_PASSWORD_ERROR_TOO_MANY_ATTEMPTS:
                'You have exceeded the number of allowed password change attempts. Please wait a while and try again later.',
            CHANGE_PASSWORD_ERROR_WRONG_CURRENT_PASSWORD:
                'Your current password is incorrect.',
            CHANGE_PASSWORD_SUCCEEDED: 'Your password has been updated.',
            DELETE_ENTITY_FAILED: 'There was a problem deleting your entity.',
            DELETE_ENTITY_SUCCEEDED: 'Your entity was deleted.',
            INVALID_EMAIL_ADDRESS: 'Please enter a valid email address.',
            INVITE_FAILED: 'There was a problem sending your invite.',
            INVITE_SUCCEEDED: 'Your invite has been sent!',
            REMOVE_AVATAR_IMAGE_FAILED:
                'There was a problem removing your profile image.',
            SUBSCRIPTION_UPDATE_ERROR:
                'There was a problem updating your subscription.',
            UPLOAD_AVATAR_IMAGE_FAILED:
                'There was a problem uploading your profile image.',
            UPLOAD_ONE_IMAGE_AT_A_TIME:
                'You may only upload one profile image at a time.',
        },
    },
    ALL_ENTITIES: 'All Entities',
    ALL_ENTITIES_AVATAR_LABEL: 'All',
    ALL_STATEMENTS: 'All Statements',
    API_ERRORS: {
        addGapToTrqkUser:
            'There was a problem when selecting your performance period for analysis.',
        analyzeTrqkGap: 'There was a problem when running your gap analysis.',
        analyzeTrqkGapChannel: 'There was a problem when loading this channel.',
        exportGapAnalysis:
            'There was a problem when exporting your gap analysis report for download.',
        exportDetections:
            'There was a problem when exporting your detections for download.',
        getGapAnalysis:
            'There was a problem when fetching your gap analysis report.',
        listGapAnalysisFilters:
            'There was a problem when fetching your list of gap analysis options.',
        listGapAnalysisSummaries:
            'There was a problem when fetching your list of gap analysis reports.',
        listGapChannelAudios:
            'There was a problem when fetching your gap analysis works list.',
        listGapChannelAudiosForGapReportAudios:
            'There was a problem when fetching your gap analysis for viewing.',
        listGapChannels:
            'There was a problem when fetching your gap analysis channel list.',
        listPeriodSelections:
            'There was an error when fetching your gap analysis periods.',
        updateTrqkGapChannelAudios:
            'There was a problem when saving your changes for this channel.',
        updateSingleTrqkGapChannelAudio:
            'There was a problem when saving your edits for this detected audio file.',
        updateTrqkGapSelections:
            'There was a problem when saving your changes for this report.',
    },
    APP_VERSION_STATUS: {
        CLICK_TO_REFRESH:
            'Click below to refresh your browser and see the latest version.',
        UPDATE_AVAILABLE: 'Update Available',
        UPDATE_NOW: 'Update Now',
    },
    AUDIO_ATTACH_ERROR:
        'We were unable to attach the audio file. Please try again.',
    AUDIO_DELETE_CONFIRMATION: 'Audio file deleted.',
    AUDIO_DELETE_ERROR:
        'We were unable to delete the audio file. Please try again.',
    AUDIO_REPLACE_CONFIRMATION: 'Audio file replaced.',
    AUDIO_REPLACE_ERROR:
        'We were unable to replace the audio file. Please try again.',
    AUDIO_UPLOAD_CTA:
        'Drag and drop audio files here to monitor for real-time performance detections.',
    AUDIO_UPLOAD_ERROR: 'We were unable to upload the audio file',
    AUTH_LAYOUT: {
        BUTTONS: {
            CANCEL: 'Cancel',
        },
    },
    CHART_COLLECTIONS: {
        MEDIA_EXPLORER: {
            CTA: 'Select media to explore further',
            TITLE: 'Media Explorer',
        },
    },
    CHART_HAS_NO_DATA: 'This chart currently has no data.',
    CHECKED_STATEMENTS: 'Selected Statements',
    CLIENT_EVENTS: {
        TITLE: 'Client Events',
    },
    COMPONENTS: {
        ACTIVE_UPLOADS: {
            DEFAULT_STATUS: 'Upload starting',
        },
        GLOBAL_FILTER: {
            PLACEHOLDER: 'Search . . .',
        },
        TABLE: {
            TOGGLE_CELL: {
                OFF: 'Off',
                ON: 'On',
            },
        },
    },
    CONFIRM_PASSWORD_RESET: {
        BUTTONS: {
            REQUEST_CODE: 'Reset Password',
        },
        CTA: 'Enter the verification code that was emailed to you.',
        ERRORS: {
            RESET_PASSWORD_ERROR:
                'There was a problem resetting your password.',
        },
        TITLE: 'Reset your password',
    },
    DATE_RANGES: {
        ALL_DATES: 'All Dates',
        CURRENT_QUARTER: 'Current Quarter',
        PAST_7_DAYS: 'Past 7 Days',
        PAST_30_DAYS: 'Past 30 Days',
        PAST_90_DAYS: 'Past 90 Days',
        PAST_YEAR: 'Past Year',
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
    },
    DEFAULT_API_ERROR: 'We encountered an unexpected result. Please try again.',
    DETECTIONS: {
        BUTTONS: {
            CLEAR_FILTERS: 'Clear Filters',
            HIDE: 'Hide',
            MANAGE_DETECTIONS: 'Manage Detections',
            SHOW: 'Show',
            DOWNLOAD_AS: 'Download As...',
        },
        CURRENT_DATA_EMPTY:
            'There is no detection data for the current filter selection.',
        DESCRIPTION: {
            PART_1: 'We monitor 300+ TV channels in total across 20+ countries.',
            PART_2: 'Upload audio files for tracks that you would like to be monitored.',
        },
        DETECTIONS_FROM: 'Detections from:',
        DETECTION_TOTALS: 'Detection Totals',
        EMPTY_STATE: {
            ADD_AUDIO_TO_GET_STARTED: 'Add audio files to get started',
            HERE: 'here',
            UPLOAD_AUDIO: 'Upload your audio files',
        },
        ERRORS: {
            FETCH_DETECTIONS_ERROR:
                'There was a problem when fetching your detection data.',
            FETCH_TRQK_SONG_ERROR:
                'There was a problem when fetching your detection song data.',
        },
        FILTERS: {
            CHANNELS: {
                ALL: 'All Stations',
            },
            CONFIDENCES: {
                ALL: 'All Confidences',
            },
            COUNTRIES: {
                ALL: 'All Countries',
            },
            DURATIONS: {
                ALL: 'All Durations',
            },
            EPISODES: {
                ALL: 'All Episodes',
            },
            FILENAMES: {
                ALL: 'All Audio Filenames',
            },
            MARKETS: {
                ALL: 'All Markets',
            },
            PROGRAM_PRODUCTION_COMPANIES: {
                ALL: 'All Production Companies',
            },
            PUBLISHERS_AND_WRITERS: {
                ALL: 'All Publishers/Writers',
            },
            SHOWS: {
                ALL: 'All Shows',
            },
            STATION_NAMES: {
                ALL: 'All Stations',
            },
            TITLES: {
                ALL: 'All Work Titles',
            },
            TRACKS: {
                ALL: 'All Tracks',
            },
        },
        INFO_MESSAGES: {
            ALREADY_BEING_GENERATED:
                'Your download is already being generated - you’ll see a notification when it is complete.',
            DOWNLOAD_BEING_GENERATED:
                'Your download is being generated. This may take a few minutes.',
        },
        TITLE: 'Detections',
        ROW_COUNT: 'Row Count',
    },
    DROPPED_WRONG_FILE_TYPE: {
        AUDIO: 'You may only upload .mp3, .aif or .wav files.',
        IMAGES: 'You may only upload .png or .jpg files.',
        STATEMENTS: 'You may only upload .csv files.',
    },
    ENABLE_DETECTION_REMINDER: {
        BODY: {
            PART_1: 'Enable detection to start monitoring live TV and radio stations for performances of your tracks. Keep detection enabled for at least one PRO reporting period so you can perform a Gap Analysis.',
            PART_2: 'Did you know that Trqk has partnered with BMAT to provide best-in-class performance monitoring? We listen for performances of your tracks on 355 TV channels - 15O in the US and 205 across 20 other countries.',
        },
        ENABLE_DETECTION: 'Enable Detection',
        TITLE: 'Detection Is Not Enabled',
    },
    ENTITY_TYPE_MAP: {
        MUSIC_USER_GENRE: 'medium',
        PUBLISHER: 'publisher',
        SUBPUBLISHER: 'subpublisher',
        TRACK: 'track',
        UNKNOWN: 'unknown',
        WRITER: 'writer',
    },
    EXPIRATION_DATE: {
        DAY: 'day',
        DAYS: 'days',
        EXPIRED: 'expired',
        EXPIRES: 'expires',
        HOURS: 'hours',
        IN: 'in',
        MONTHS: 'months',
        ON: 'on',
        ONE_HOUR: 'one hour',
        RENEWS: 'renews',
        TODAY: 'today',
        TOMORROW: 'tomorrow',
    },
    FILE_UPLOAD_CANCELED_CONFIRMATION: 'File upload canceled.',
    FILE_UPLOAD_MUST_BE_SINGLE_ERROR:
        'You may only add one audio file to a given track. Please try again',
    FORGOT_PASSWORD: {
        BUTTONS: {
            REQUEST_CODE: 'Request Code',
        },
        CTA: 'Enter your email address to receive a verification code.',
        ERRORS: {
            REQUEST_CODE_ERROR:
                'There was a problem when requesting your verification code.',
        },
        TITLE: 'Forgot your password?',
    },
    FREE_TRIAL_FOOTER: {
        UPGRADE_NOW: 'Upgrade Now',
        YOUR_FREE_TRIAL: 'Your Free Trial',
    },
    GAP_ANALYSIS: {
        DESCRIPTION: {
            PART_1: 'Create reports that compare performances reported by your PRO vs. detections of your on-air tracks.',
            PART_2: 'Download reports in Excel format to use the supporting data in claims for missing royalties.',
        },
        EXPLAINER: {
            INTRO: {
                GAP_ANALYSIS: 'Gap Analysis',
                REPORT_WILL_BE_AVAILABLE: {
                    BASIC_TO_PRO:
                        'report will be available after detection is enabled on at least one audio file for at least one full PRO reporting period (i.e. calendar quarter).',
                    SCALE: 'report will be available as an add-on feature after detection is enabled on at least one audio file for at least one full PRO reporting period (i.e. calendar quarter).',
                },
                THE: 'The',
                TO_RUN_REPORT:
                    'To run a Gap Analysis report, follow these steps:',
            },
            STEP_FOUR: {
                COME_BACK:
                    'Come back to this page to create a Gap Analysis report.',
            },
            STEP_ONE: {
                FOR_TRACKS_ON_AIR:
                    'for tracks you expect to be on air - either recently, now, or in the near future.',
                UPLOAD_AUDIO_FILES: 'Upload audio files',
            },
            STEP_THREE: {
                TO_TRQK_IQ: 'to TrqkIQ.',
                UPLOAD_THAT_STATEMENT: 'upload that statement',
                WHEN_YOUR_PRO:
                    'When your PRO issues the statement for the reporting period from step 2,',
            },
            STEP_TWO: {
                ENABLE_DETECTION: 'Enable detection',
                FOR_THOSE_AUDIO_FILES:
                    'for those audio files, and leave it on for at least one full PRO reporting period.',
            },
            TITLE: 'Gap Analysis',
        },
        MANAGE_GAP_ANALYSIS: 'Create Gap Analysis',
        REPORT_SUMMARY_TABLE: {
            CURRENT_DATA_EMPTY:
                'There are no completed Gap Analysis reports display.',
            HEADERS: {
                CHANNELS_INCLUDED: 'Channels Included',
                DATE_CREATED: 'Date Created',
                DELETE: 'Delete',
                DOWNLOAD: 'Download',
                EDIT: 'Edit',
                FILENAME: 'Detection File Name',
                PERFORMANCE_PERIOD: 'Performance Period',
                PRO: 'PRO',
                REPORT_NAME: 'Report Name',
                VIEW: 'View',
            },
        },
        REPORT_VIEWER_TABLE: {
            BUTTONS: {
                DOWNLOAD: 'Download',
                DOWNLOAD_AS: 'Download As...',
                EDIT: 'Edit',
            },
            CURRENT_DATA_EMPTY: 'There are no channels or works to display.',
            DEFAULT_DESCRIPTION: 'Gap Analysis Report',
            DOWNLOAD_AS_DIALOG: {
                FILENAME: 'Filename:',
                HEADER: 'Download As',
            },
            FOOTERS: {
                CHANNEL_NAME: 'Report Total',
            },
            HEADERS: {
                CHANNEL_NAME: 'Channel',
                DETECTIONS: 'Detect.',
                ESTIMATED_LOSS: 'Estimated Loss',
                GAP: 'Gap',
                PERFORMANCES: 'Perf.',
                PROGRAM_AND_SERIES: 'Program / Series',
                SURVEY_TYPE: 'Survey Type',
                TRACK_NAME: 'Work Title / Audio',
                USE_CODE: 'Use Code',
            },
            CELLS: {
                GROUPED_TRACK_NAME: {
                    MATCHES: 'matches',
                },
            },
        },
        TITLE: 'Gap Analysis',
    },
    HELP: {
        DOWNLOAD_PRO_STATEMENTS: {
            ALT_TEXT:
                'Screenshot showing how to download CSV statement from PRO account',
            PRO_PROVIDES_PDF_CSV:
                'Your PRO provides statements in PDF and CSV.',
            STEPS: {
                STEP_1: {
                    PART_1: 'Go to your',
                    PART_2: 'PRO account',
                },
                STEP_2: {
                    PART_1: 'Go to',
                    PART_2: 'Statements',
                },
                STEP_3: 'Download CSV format',
            },
            VIEW_SCREENSHOT_FOR: 'View screenshot for:',
        },
        HOW_INGESTION_WORKS: {
            INGESTION_IS_COMPLEX: 'Statement ingestion is a complex process',
            STAGES: {
                STAGE_1: 'Your CSV file is uploaded to our file server.',
                STAGE_2: {
                    PART_1: 'We use data science methods to parse and analyze the data in your CSV file.',
                    PART_2: 'This is a multi-step process that we refer to as "ingestion."',
                },
            },
            UPLOADS_HAVE_TWO_STAGES: 'Statement uploads happen in two stages',
            WHY_INGESTION_IS_COMPLEX:
                'There is no standard data format for PRO statements, which means we have to adapt to every anomaly that may be present in the files created by PROs. This requires continual improvement of our ingestion pipeline. Our ability to ingest various statements and support more PROs will improve over time.',
        },
        PERFORMANCE_VS_STATEMENT_PERIODS: {
            DEFINITIONS: {
                PERFORMANCE_PERIOD: {
                    PART_1: 'A',
                    PART_2: 'performance period',
                    PART_3: 'is a calendar quarter during which your works were performed, i.e. played on air or streamed online.',
                },
                STATEMENT_PERIOD: {
                    PART_1: 'A',
                    PART_2: 'statement period',
                    PART_3: '(or "distribution period") is a calendar quarter during which your PRO issued you a statement for a prior performance period.',
                },
            },
            EXAMPLE: {
                CHART: {
                    CALENDAR_QUARTER: 'Calendar Quarter',
                    PERFORMANCE_PERIOD: 'Performance Period',
                    Q1: 'Q1',
                    Q2: 'Q2',
                    Q3: 'Q3',
                    Q4: 'Q4',
                    STATEMENT_PERIOD: 'Statement Period',
                },
                DESCRIPTION:
                    'ASCAP usually sends out their domestic publisher statements in September for the performance period that includes January, February and March. This is the Q3 statement period, but it covers the Q1 performance period.',
                TITLE: 'Example:',
            },
            TITLE: 'Performance Periods vs. Statement Periods',
        },
    },
    INGESTION: {
        ERRORS: {
            ADD_STATEMENT_ERROR: 'Failed to add statement to TrqkDirectory',
            ADD_STATEMENT_RESPONSE_EMPTY:
                'No result returned from addStatementToTrqkUser',
            GET_STATEMENT_VIEW_EMPTY:
                'Empty response from getTrqkStatementView',
            INGESTION_ERROR: 'Ingestion error',
            INGESTION_TIMEOUT: 'Ingestion timed out',
            QRR_EXCEEDED: {
                BY: 'by',
                EARNINGS_OF: 'Earnings of',
                WOULD_EXCEED_CAPACITY_OF: 'would exceed capacity of',
            },
            S3_UPLOAD_ERROR: 'Failed to upload statement file to S3',
        },
        STATUS_MESSAGES: {
            ALL: 'all',
            ANALYZING: {
                PART_1: 'Compiling data for',
                PART_2: 'tracks in statement',
            },
            BUILDING: 'Beginning analysis of statement',
            COMPLETE: 'Dashboard build complete',
            PENDING: 'Dashboard build beginning',
            PROCESSING: 'Processing statement',
            RENDERING: {
                PART_1: 'Building data visualizations for',
                PART_2: 'performances',
            },
            STARTING_INGESTION: 'Starting ingestion',
            UPLOADING: 'Uploading statement',
        },
        TOASTS: {
            FETCH_STATEMENT_FAILURE:
                'We were unable to fetch your statement. Please wait a moment and refresh your browser.',
            MAX_UPLOAD_BATCH_EXCEEDED: {
                PART_1: 'You can upload up to',
                PART_2: 'statements at once.',
                PART_3: 'Please wait until some uploads have completed.',
            },
            SOME_STATEMENTS_FAILED: {
                ALERTS_TAB: 'Alerts tab',
                OF_THE_STATEMENT_MANAGER: 'of the statement manager.',
                ONE_OR_MORE_STATEMENTS_EXCEEDED_CAPACITY:
                    'One or more of your statements exceeded your payment plan capacity.',
                TO_CONTINUE_UPLOADING: 'to continue uploading statements.',
                UPDATE_YOUR_PLAN: 'Update your plan',
                YOU_CAN_SEE_RESULTS: 'You can see your upload results in the',
            },
            STATEMENT_FAILURE: {
                COULD_NOT_INGEST: {
                    CAN_RETRY: 'You may be successful if you try again.',
                    LABEL: 'Could not ingest',
                    PART_1: 'This can happen if the statement contains data in a non-standard format or the file is too large for our system.',
                    PART_2: 'We are actively improving our ability to handle these statements.',
                    REPORT_ISSUE: 'Report this issue to:',
                    REPORT_ISSUE_EMAIL: {
                        BODY: {
                            GREETING: 'Hello,',
                            PART_1: "I'm experiencing an error during statement ingestion; details of the error are below.",
                            SIGN_OFF: 'Thanks!',
                        },
                        SUBJECT: 'Trqk statement ingestion error report',
                    },
                    TITLE: {
                        NOT_ABLE_TO_INGEST:
                            'We were not able to ingest your PRO statement.',
                        TOOK_TOO_LONG:
                            'Your statement took too long to ingest.',
                    },
                },
                DUPLICATE_STATEMENT: {
                    PART_1: "It looks like you're trying to upload a statement that has already been ingested.",
                    PART_2: 'To correctly analyze your data, Trqk only adds one copy of each statement to your account.',
                    TITLE: 'Duplicate Statement',
                },
                ERROR_MESSAGE: 'Error message:',
                INFO_FOR: 'Info for',
                INGESTION_ISSUE: 'Ingestion Issue',
                INVALID_STATEMENT: {
                    PART_1: 'It looks like the .csv file you uploaded is not a valid PRO statement.',
                    PART_2: 'To download a PRO statement:',
                },
                OF_YOUR_STATEMENTS: 'of your statements',
                THERE_WAS_A_PROBLEM_WITH: 'There was a problem with',
            },
            STATEMENT_SUCCESS: {
                INGESTED_SUCCESSFULLY: 'ingested successfully.',
                OF_YOUR_STATEMENTS_WAS: 'of your statements was',
                OF_YOUR_STATEMENTS_WERE: 'of your statements were',
            },
            UPLOAD_ISSUE: 'Upload issue',
            UPLOADS_ARE_FINISHED: {
                COMPLETE_TAB: 'Complete tab',
                GOOD_NEWS: 'Good news!',
                OF_THE_STATEMENT_MANAGER: 'of the statement manager.',
                YOU_CAN_SEE_RESULTS: 'You can see your upload results in the',
                YOUR_UPLOADS_ARE_FINISHED:
                    'Your statement uploads are finished.',
            },
            PLAN_EXPIRED: {
                TITLE: 'Payment plan expired',
                PLEASE_UPDATE_YOUR_PLAN:
                    'Please update your plan to continue uploading',
                UPDATE_PLAN: 'Update Plan',
            },
        },
    },
    INPUT_VALIDATION: {
        ENTER_A_VALID_EMAIL: 'Please enter a valid email address.',
        SOMETHINGS_WRONG: "Something's wrong",
    },
    INSIGHTS: {
        CARDS: {
            BUMP_FALLOFF: {
                DECREASE: 'Overall decrease',
                HEADER: {
                    PART_1: 'Difference between',
                    PART_2: 'for',
                },
                INCREASE: 'Overall increase',
                NULL_PERCENT_LABELS: {
                    MISSING_IN_NEW: 'Falloff',
                    MISSING_IN_OLD: 'New',
                },
                OF: 'of',
                TITLE: 'Bump & Falloff',
                TOP_DECREASE: 'Top decrease',
                TOP_INCREASE: 'Top increase',
            },
            CURRENT_ENTITY: 'the current entity',
            DETECTION_SUMMARY: {
                EMPTY_MESSAGE: 'There are no detections to display.',
                HEADER: {
                    PART_1: 'Tracks with the most detections for the',
                    PART_2: 'past year',
                },
                TITLE: 'Detection Summary',
            },
            DETECTIONS_BY_PRODUCTION_COMPANY: {
                EMPTY_MESSAGE: 'There are no detections to display.',
                HEADER: {
                    PART_1: 'Sync users with the most detections in the',
                    PART_2: 'past year',
                },
                TITLE: 'Top Production Companies',
            },
            DID_YOU_KNOW: {
                BODY: {
                    PART_1: 'TrqkIQ has analyzed thousands of royalty statements from our network, and has determined that the highest-paying performances are',
                    PART_2: 'long-duration performances',
                    PART_3: 'on',
                    PART_4: 'live primetime network shows.',
                },
                TITLE: 'Did You Know?',
            },
            STATEMENT_HISTORY: {
                HEADER: {
                    PART_1: 'Total earnings over time for',
                },
                TITLE: 'Statement History',
                VIEW_FULL_REPORT: 'View Full Report',
            },
            STEP_1_ADD_STATEMENTS: {
                BODY: 'Discover royalty changes over time.',
                FOOTER: 'Upload a statement (.csv)',
                TITLE: 'Add Statements',
            },
            STEP_2_SET_UP_DETECTIONS: {
                BODY: 'Detect tracks playing on air.',
                FOOTER: 'Upload tracks (.wav, .mp3, .aif)',
                TITLE: 'Set Up Detections',
            },
            STEP_3_GAP_ANALYSIS: {
                BODY: {
                    PART_1: 'Match audio files to their statement tracks to run analysis. Identify',
                    PART_2: 'unreported performances.',
                },
                TITLE: 'Gap Analysis',
            },
            STEP_4_TRACK_PLACEMENTS: {
                BODY: {
                    AND: 'and',
                    PART_1: 'See who is licensing and using your works. View your',
                    PART_2: 'Earnings Breakdown',
                    PART_3: 'Top Publishers',
                    PART_4: 'Top Production Companies',
                },
                TITLE: 'Track Your Placements',
            },
            STEP_5_NEGOTIATE_DEALS: {
                BODY: {
                    PART_1: 'Get',
                    PART_2: 'payout ranges',
                    PART_3: 'for performances by channel to strengthen your TV placement strategy.',
                },
                TITLE: 'Negotiate Better Sync Deals',
            },
            STEP_6_INVITE_OTHERS: {
                BODY: {
                    PART_1: 'Send invites',
                    PART_2: 'to writers and publishers for more detailed statement analysis and more fun!',
                },
                TITLE: 'Invite Others',
            },
            TOP_FIVE: {
                TOP_EARNING_PROGRAMS: {
                    HEADER: {
                        PART_1: 'Highest-earning shows for',
                    },
                    TITLE: 'Top Earning Programs',
                },
                TOP_EARNINGS_PER_PLAY: {
                    HEADER: {
                        PART_1: 'Highest earnings in a single play from the',
                    },
                    TITLE: 'Top Earnings per Play',
                },
            },
            TOP_PUBLISHERS: {
                EMPTY_MESSAGE:
                    'There are no publishers to show for the current entity.',
                HEADER: {
                    PART_1: 'Publishers with the most earnings for the',
                    PART_2: 'past four statements',
                },
                TITLE: 'Top Publishers',
            },
            TOP_WRITERS: {
                EMPTY_MESSAGE:
                    'There are no writers to show for the current entity.',
                HEADER: {
                    PART_1: 'Writers with the most earnings for the',
                    PART_2: 'past four statements',
                },
                TITLE: 'Top Writers',
            },
            WELCOME: {
                HERE: 'here',
                HOW_TO_GET_STARTED: "Here's how to get started",
                PART_1: 'Trqk helps music creators and publishers grow their royalties with strategic insights.',
                PART_2: 'We analyze data in statements and real-time performance detections to reveal high earners, detection gaps, growth opportunities, and more!',
                TITLE: 'Welcome to Trqk!',
            },
        },
        INSIGHTS_DESCRIPTION: {
            PART_1: 'Your key data trends, powered by the',
        },
        INSIGHTS_TITLE: 'Insights',
        TOUR_DESCRIPTION: 'Follow these steps to get started',
        TOUR_TITLE: 'Guided Tour',
    },
    INTERNATIONAL_STATEMENTS: 'International',
    INVITE_PRO: 'PRO',
    INVITE_WRITER: 'Writer',
    LAST_TWO_STATEMENTS: 'Last Two Statements',
    LOG_EVENT_ERRORS: {
        analyzeGapChannel:
            'There was a problem when analyzing a channel for your gap analysis report.',
        detectionBatchAddedToGap:
            'There was a problem when initializing your gap analysis report.',
        gapAnalysisExported:
            'There was a problem when exporting your gap analysis report for download.',
        detectionExportReady:
            'There was a problem when exporting your detection data for download.',
    },
    MANAGE_DETECTIONS: {
        BUTTONS: {
            APPLY: 'Apply',
            CANCEL: 'Cancel',
            CLEAR_SELECTION: 'Clear Selection',
            DELETE_AUDIO: 'Delete Audio',
            UPLOAD_AUDIO_FILES: 'Upload Audio Files',
        },
        DESCRIPTION: {
            DRAG_DROP_OR_BROWSE: {
                PART_1: 'To add a track for detection, drag and drop audio files here',
                PART_2: 'or browse to add.',
            },
        },
        DETECTION_SETTINGS: {
            DETECTION_COVERAGE: 'Detection Coverage',
            DURATION_INFO:
                'To best match detections to your PRO-reported performances, we need to run detection for at least one calendar quarter (3 months).',
            ENABLED_STATUS: {
                AFTER_YOU_CLICK_APPLY:
                    'After you click Apply, you will have enabled detection for',
                AVAILABLE_TRACKS: 'available tracks in your',
                OF_THE: 'of the',
                UPDATE_PAYMENT_PLAN: 'Update Payment Plan',
                YOU_HAVE_ENABLED: 'You have enabled detection for',
            },
            GLOBAL_FILTER_PLACEHOLDER: 'Search for a track ...',
            PLAN_TYPE_LABELS: {
                BASIC: 'Basic Plan',
                CATALOG_ANALYSIS: 'Catalog Analysis Plan',
                LITE: 'Lite',
                NEW_BASIC: 'Basic',
                NEW_PRO: 'Pro',
                PRO: 'Pro Plan',
                PUBLISHER: 'Publisher',
                RISE: 'Rise',
                SCALE: 'Scale',
                TRIAL: 'Free Trial',
                UNKNOWN: 'payment plan',
            },
            START_DATE_INFO:
                'It may take up to 24 hours after you start detection for your track to be live in the detection system.',
        },
        TAB_LABELS: {
            ALERTS: 'Alerts',
            DETECTION_SETTINGS: 'Detection Settings',
            UPLOADS: 'Uploads',
        },
        TITLE: 'Manage Detections',
        TOASTS: {
            AUDIO_DELETIONS_SUCCEEDED_PLURAL:
                'Your audio files have been deleted.',
            AUDIO_DELETIONS_SUCCEEDED_SINGULAR:
                'Your audio file has been deleted.',
            DELETE_AUDIO_WARNING: {
                BUTTONS: {
                    CANCEL: 'Cancel',
                    CONFIRM: 'Confirm',
                },
                DESCRIPTION: {
                    IF_YOU_DO_THIS: 'If you do this:',
                    PLURAL: {
                        AUDIO: 'audio files',
                        AUDIO_WILL_BE_DELETED:
                            'Your audio files will be deleted from our server.',
                        DETECTIONS_STILL_EXIST:
                            'You will still see existing detections for these audio files, but statement works will no longer be matched to these audio files.',
                    },
                    SINGULAR: {
                        AUDIO: 'audio file',
                        AUDIO_WILL_BE_DELETED:
                            'Your audio file will be deleted from our server.',
                        DETECTIONS_STILL_EXIST:
                            'You will still see existing detections for this audio file, but statement works will no longer be matched to this audio file.',
                    },
                    YOU_ARE_ABOUT_TO_DELETE: 'You are about to delete',
                },
                TITLE: 'Warning',
            },
            GAP_ANALYSIS_UNAVAILABLE: {
                BUTTONS: {
                    APPLY_ANYWAY: 'Apply Anyway',
                    MAKE_CHANGES: 'Make Changes',
                },
                DESCRIPTION:
                    'Detection has been turned off before the end of a full quarter. Gap analysis will not be available for this quarter.',
                TITLE: 'Gap Analysis Unavailable',
            },
            MAX_DETECTIONS_EXCEEDED: {
                BUTTONS: {
                    OK: 'OK',
                },
                DESCRIPTION: {
                    PART_1: 'Your account currently allows detection for',
                    PART_2: 'a maximum of',
                    PART_3: 'tracks',
                    PART_4: 'You may turn off detection on another track to begin monitoring this one.',
                },
                TITLE: 'Maximum Number of Detections',
            },
            SOME_AUDIO_DELETIONS_FAILED:
                'One or more audio files were not deleted due to an internal error.',
            SOME_UPDATES_FAILED:
                'One or more detection updates were not processed due to an internal error.',
            UPDATES_FAILED:
                'Your detection updates were not processed due to an internal error.',
            UPDATES_SUCCEEDED: 'Your detection settings have been updated.',
        },
        UPLOADS: {
            AVAILABLE: {
                ALLOWS: 'allows',
                FILE: 'file',
                FILES: 'files',
                MORE_AUDIO: 'more audio',
                OF_YOUR_FILES: 'of your audio files',
                TO_BE_UPLOADED:
                    'to be uploaded. You can enable detection for up to',
                YOUR: 'Your',
            },
            EMPTY_STATE: {
                DETAILS_SHOWN_HERE:
                    'When you are uploading an audio file, you will see details of its progress here.',
                NO_ACTIVE_UPLOADS: 'There are no active uploads.',
            },
        },
    },
    MANAGE_GAP_ANALYSIS: {
        BACK_BUTTON_LABEL: 'Back',
        DATA_LABELS: {
            DETECTIONS: 'Detections',
            PERFORMANCES: 'Performances',
        },
        ERROR_MESSAGES: {
            LIST_PERIOD_SELECTIONS:
                'There was an error when fetching your gap analysis periods.',
        },
        INFO_MESSAGES: {
            REPORT_BEING_GENERATED:
                'Your report is being generated. This may take a few minutes.',
        },
        REPORT_PERIOD_SELECTOR: {
            DETECTIONS: 'Detections',
            PERFORMANCE_PERIODS: 'Performance Periods',
            PERFORMANCES: 'Performances',
            PERIOD: 'Period',
            SELECT_PERIOD: 'Select period for Gap Analysis',
        },
        STEPS: {
            ANALYZING_DATA: {
                AFTER_COMPLETE:
                    'After analysis is complete, the next steps are:',
                DEFAULT_TITLE: 'Analyzing Data',
                ERROR_MESSAGES: {
                    EMPTY_DETECTIONS: {
                        EXPLANATION:
                            'This can happen if there were no detections during the selected period, or if your filter settings have filtered out detections.',
                        WARNING_FOR_DATE_RANGE:
                            'Your gap analysis has resulted in an empty data set from',
                        WARNING_FOR_SELECTED_PERIOD:
                            'Your gap analysis has resulted in an empty data set for the selected period.',
                    },
                    FAILURE: 'There was an error during data analysis.',
                    HOW_TO_TRY_AGAIN:
                        'To try again, go back and upload a different detection file, or upload the same detection file and change your filter settings.',
                    TRY_AGAIN: 'Try Again',
                },
                IN_PROGRESS_LABEL: {
                    ANALYSIS_COMPLETE: 'Analysis complete',
                    ANALYSIS_FAILED: 'Analysis failed',
                    ANALYZING_DATA: 'Analyzing data ...',
                },
                NEXT_STEPS: {
                    STEP_1: 'Confirm channels to include in your report',
                    STEP_2: 'Confirm works to include in each channel',
                    STEP_3: 'Create your report and download it',
                },
                PERFORMANCE_PERIOD: 'Performance period:',
            },
            CONFIRM_CHANNELS: {
                CHANGES_HAVE_BEEN_SAVED: 'Your changes have been saved.',
                COLUMN_FOOTERS: {
                    CHANNEL: 'Report Total',
                },
                COLUMN_HEADERS: {
                    ADS_AND_PROMOS: 'Ads & Promos',
                    AUDIOS: 'Audios Total',
                    CHANNEL: 'Channel',
                    DATA_STATUS: 'Data Status',
                    DETECTIONS: 'Detections',
                    DETECTIONS_SUB_LABEL: 'Total',
                    ESTIMATED_LOSS: 'Estimated Loss',
                    GAP: 'Gap',
                    INCLUDE_CHANNEL: 'Include in Report',
                    INCLUDED_AUDIO_FILES: 'Included Audio Files',
                    PAYMENTS: 'Payments Total',
                    PERFORMANCES_SUB_LABEL: 'Matched',
                    PERFORMANCES: 'Performances',
                    PROGRAMS: 'Programs',
                },
                DEFAULT_TITLE: 'Confirm Channels',
                GLOBAL_FILTER_PLACEHOLDER: 'Search for a channel . . .',
                NEXT_BUTTON_LABEL: 'View / Download',
                SAVE_CHANGES: 'Save Changes',
            },
            CONFIRM_WORKS: {
                COLUMN_FOOTERS: {
                    AUDIO_FILE_NAME: 'Channel Total',
                    STATEMENT_WORK: 'Click “Apply” to update',
                },
                COLUMN_HEADERS: {
                    DETECTIONS: 'Detect.',
                    ESTIMATED_LOSS: 'Estimated Loss',
                    GAP: 'Gap',
                    INCLUDE_AUDIO_FILE: 'Include in Report',
                    PERFORMANCES: 'Perf.',
                    STATEMENT_WORK: 'Statement Work',
                    SURVEY_TYPE: 'Survey Type',
                    USE_CODE: 'Use Code',
                    WORK_NAME: {
                        BMAT: 'Title / Artist',
                        SOURCE: 'Title / Artist',
                        TUNESAT: 'Title / Artist',
                        TRQK: 'Detection Work',
                    },
                    GAP_AUDIO_ID: 'Gap Audio ID',
                    MATCHED_WORK_ID: 'Matched Work ID',
                },
                CELLS: {
                    GROUPED_WORK_NAME: {
                        DETECTED_AUDIO: 'Detected Audio',
                        FILE: 'File',
                        FILES: 'Files',
                    },
                },
                DEFAULT_TITLE: 'Confirm Works',
                ERROR_STATE: {
                    CONTACT_SUPPORT: 'Contact Support',
                    EMAIL_CONTENT: {
                        BODY_PART_1:
                            'I’m having trouble with analyzing a channel while creating a Gap Analysis report. My Trqk user ID is:',
                        BODY_PART_2: 'The gap analysis ID is:',
                        BODY_PART_3: 'The channel ID is:',
                        BODY_PART_4: '[Enter any other details here.]',
                        GREETING: 'Hello,',
                        SIGN_OFF: 'Thanks!',
                        SUBJECT: 'Help with Gap Analysis report',
                    },
                    RETRY: 'Retry',
                },
                ERRORS: {
                    CHANNEL_STATUS_ERROR:
                        'There was a problem when analyzing the works for this channel.',
                    GET_TRACK_NAME_MATCHES:
                        'There was an error when fetching your list of track name matches',
                },
                GLOBAL_FILTER_PLACEHOLDER: 'Search for a work title . . .',
                LOADING_STATE: {
                    DESCRIPTION: {
                        PART_1: 'We’re comparing your detected audio files to works in your catalog, suggesting matches, gathering performance data, and estimating missed payouts.',
                        PART_2: 'It sounds like a lot, but it will only take a few minutes.',
                    },
                    IN_PROGRESS_LABEL: 'Analyzing works...',
                    LABEL: 'Preparing channel',
                },
                NEXT_BUTTON_LABEL: 'Apply',
                SELECT_ALL: 'Select All',
            },
            SELECT_OPTIONS: {
                DEFAULT_TITLE: 'Select Options',
                DESCRIPTION: 'Select Analysis Options',
                NEXT_BUTTON_LABEL: 'Run Analysis',
            },
            SELECT_PERIOD: {
                DEFAULT_TITLE: 'Select Period',
                DESCRIPTION: {
                    PART_1: 'A Gap Analysis is a comparison of the performances reported on your statements vs. on-air detections of your audio. A Gap Analysis must be run for one one full',
                    PART_2: 'performance period',
                    PART_3: 'You must have both performance data (from a PRO statement) and detection data for the same period. You can use either internal Trqk detection data or external data via file upload.',
                    PART_3_CANNOT_UPLOAD:
                        'You must have both performance data (from a PRO statement) and detection data for the same period.',
                    PART_4: 'We currently support external detection data from BMAT and TuneSat.',
                },
                NEXT_BUTTON_LABEL: 'Set Up Gap Analysis',
                NEXT_STEPS: {
                    CONFIRM_SELECTION:
                        'You’ll be asked to confirm your selection in the next step.',
                    SELECT_PERIOD_TO_PROCEED:
                        'Select a performance period to proceed.',
                    SELECT_PERIOD_WITH_DETECTIONS:
                        'You must select a period with detection data to proceed.',
                    UPLOAD_DETECTIONS:
                        'You’ll be asked to upload detection data in the next step.',
                    UPLOAD_STATEMENT:
                        'You’ll be asked to upload a statement in the next step.',
                    UPLOAD_STATEMENT_AND_DETECTIONS:
                        'You’ll be asked to upload a statement and detection data in the next step.',
                },
                NO_STATEMENTS_MESSAGE: {
                    PART_1: 'You must',
                    PART_2: 'upload a statement',
                    PART_3: 'to create a Gap Analysis report.',
                },
            },
            SET_UP: {
                CTA: {
                    CONFIRM_OR_REPLACE_DETECTIONS:
                        'Please check to make sure your detection data is complete. If not, you can replace your detections by uploading data from BMAT or TuneSat.',
                    NO_DETECTIONS:
                        'Your TrqkIQ account does not have detections within this performance period. If you have detection data from BMAT or TuneSat, you can upload it to continue.',
                    NO_PERFORMANCES:
                        'You have not uploaded the required statement for your selected performance period. Note that the statement period is typically later than the performance period.',
                    REPLACE_DETECTIONS: 'Replace Detections',
                    UPLOAD_DETECTIONS: 'Upload Detections',
                    UPLOAD_STATEMENT: 'Upload Statement',
                },
                DATA_LABELS: {
                    DATE_RANGE: 'Date Range',
                    FILE_NAME: 'File Name',
                    MISSING: 'Missing',
                    MISSING_DETECTIONS: 'Missing detections',
                    MISSING_DETECTIONS_FROM: 'Missing detections from',
                    MISSING_PERFORMANCES: 'Missing performances',
                    STATEMENT: 'Statement',
                    TO: 'to',
                },
                DEFAULT_TITLE: 'Set Up',
                DESCRIPTION: {
                    DATA_FROM:
                        'To run a Gap Analysis, you need performance and detection data from',
                    TO: 'to',
                },
                NEXT_BUTTON_LABEL: 'Run Analysis',
                REPORT_NAME_INPUT: {
                    LABEL: 'Report Name',
                    PLACEHOLDER: 'Enter a report name',
                },
            },
            UPLOAD_DETECTIONS: {
                DEFAULT_TITLE: 'Upload Detections',
                DESCRIPTION: {
                    CURRENTLY_SUPPORTED_FORMATS:
                        'We currently support detection uploads from BMAT and TuneSat.',
                    DRAG_DROP_OR_BROWSE:
                        'To upload external detections, drag and drop a .csv file here or browse to add.',
                    SINGLE_FILE_REQUIREMENT:
                        'All your detection data for this period must be in one file, so be sure your export contains data for all audio files you want to analyze.',
                },
                DETECTION_DATA_IS_UPLOADING:
                    'Your detection data is uploading now',
                DROP_TO_UPLOAD: 'Drop CSV file to upload',
                EMPTY: {
                    DETAILS_SHOWN_HERE:
                        'When you are uploading a detection file, you will see details of its progress here.',
                    NO_ACTIVE_UPLOADS: 'There are no active uploads.',
                },
                ERRORS: {
                    UPLOAD_DETECTION_FILE:
                        'There was an error when uploading your detection file.',
                },
                TITLE: 'Upload Detections',
                UPLOAD_CSV_FILE: 'Upload CSV File',
                UPLOAD_INSTRUCTIONS: {
                    BMAT: {
                        TAB_LABEL: 'BMAT',
                    },
                    TUNESAT: {
                        TAB_LABEL: 'TuneSat',
                    },
                },
                WARNINGS: {
                    ONE_FILE_AT_A_TIME:
                        'You may only upload one detection file at a time.',
                },
            },
        },
        STEP_WRAPPER: {
            HELP_INFO: {
                NEED_HELP: 'Need help? See our',
                FAQ: 'FAQ',
            },
        },
        TITLE: {
            CREATE: 'Create Gap Analysis',
            EDIT: 'Edit Gap Analysis',
        },
    },
    MANAGE_STATEMENTS: {
        DELETE_SELECTED: 'Delete Selected',
        DRAG_AND_DROP_OR_BROWSE:
            'Drag and drop CSV statements here or browse to add.',
        DROP_TO_UPLOAD: 'Drop file to upload',
        EMPTY_ACTIVE_INGESTIONS: {
            DETAILS_SHOWN_HERE:
                'When you are uploading a statement, you will see details of its progress here.',
            NO_ACTIVE_UPLOADS: 'There are no active uploads.',
        },
        FAILURE_ROWS: {
            INGESTION_FAILED: 'Ingestion failed',
            INGESTION_TIMED_OUT: 'Ingestion timed out',
        },
        HOW_DO_I_GET_A_CSV: 'How do I get a .csv of my statement?',
        HOW_DO_UPLOADS_WORK: 'How do uploads work?',
        MANAGE_GAP_ANALYSIS_HEADER: {
            CONTINUE_GAP_ANALYSIS_SETUP: 'Continue Gap Analysis Setup',
            FROM: 'from',
            NEED_TO_UPLOAD: 'You need to upload the',
            STATEMENT_TO:
                'statement to run a Gap Analysis for the performance period',
            TO: 'to',
            WHICH_RUNS: 'which runs',
            YOU_SELECTED: 'you selected',
        },
        TAB_LABELS: {
            ALERTS: 'Alerts',
            COMPLETE: 'Complete',
            TOTAL_ROYALTIES: 'Total Royalties',
            UPLOADS: 'Uploads',
        },
        TOASTS: {
            CONFIRM_STATEMENT_DELETION: {
                BUTTONS: {
                    CANCEL: 'Cancel',
                    DELETE: 'Delete',
                },
                PART_1: 'You are about to delete',
                PART_2: 'This cannot be undone.',
                STATEMENT: 'statement',
                STATEMENTS: 'statements',
            },
            ENTITY_FETCH_FAILURE:
                'We were unable to fetch your entity. Please wait a moment and refresh your browser.',
            STATEMENT_DELETION_FAILURE: {
                PART_1: 'We were not able to delete your',
                STATEMENT: 'statement.',
                STATEMENTS: 'statements.',
            },
            STATEMENT_DELETION_SUCCESS: {
                PART_1: 'Your',
                PART_2: 'deleted.',
                STATEMENT_WAS: 'statement was',
                STATEMENTS_WERE: 'statements were',
            },
            STATEMENT_FETCH_FAILURE:
                'We were unable to fetch your statements. Please wait a moment and refresh your browser.',
        },
        TOTAL_ROYALTIES: {
            AVAILABLE_IN_PLAN: 'Available in Plan',
            DATA_IS_EMPTY: {
                AFTER_YOU: 'After you',
                UPLOAD_STATEMENTS: 'upload statements,',
                YOU_WILL_SEE:
                    'you will see a chart of your total royalties here.',
            },
            DISTRIBUTION_PERIOD: 'Distribution Period',
            MOST_RECENT_MARKER:
                'The most recent quarterly royalties are shown by a square marker at the end of each line in the Total Royalties chart.',
            MOST_RECENT_QUARTERLY_ROYALTIES:
                '= Most Recent Quarterly Royalties',
            QRR_CALCULATION_INFO: {
                LINE_1: 'In your payment plan, your royalty usage is the sum of the most recent quarterly royalties for each of your entities. This is currently:',
                LINE_2: 'These royalties can be from different quarters, depending on which statements you have uploaded for each entity.',
            },
            TOTAL: 'Total',
            UNLIMITED: 'Unlimited',
        },
        UPLOAD_STATEMENTS: 'Upload Statements',
    },
    NAV_MENU: {
        LABELS: {
            CREATE: 'Create',
            DETECTIONS: 'Detections',
            GAP_ANALYSIS: 'Gap Analysis',
            INSIGHTS: 'Insights',
            MANAGE_ADD: 'Manage / Add',
            REPORTS: 'Reports',
            STATEMENTS: 'Statements',
            WORKS: 'Works',
        },
    },
    NON_STATEMENT_TRACK_CREATION_ERROR:
        'There was a problem creating your non-statement track. Please try again.',
    PLAN_NOT_ACTIVE: {
        CTA: 'Update your payment plan to continue.',
        CURRENTLY_FREE_TRIAL: {
            THANKS: 'Thanks for trying TrqkIQ™!',
            TIME_IS_UP: 'It looks like your free trial has ended.',
            TITLE: 'Trial Ended',
        },
        CURRENTLY_PAID_PLAN: {
            THANKS: 'Thanks for using TrqkIQ™!',
            TIME_IS_UP: 'It looks like your payment plan has expired.',
            TITLE: 'Payment Plan Expired',
        },
        UPDATE_PLAN: 'Update Plan',
    },
    PRODUCTS: {
        ADMIN: 'Admin',
        IQ: 'IQ',
        LICENSE: 'License',
        TAG: 'Tag',
    },
    REPORTS: {
        SECTIONS: {
            TOTAL_ROYALTIES: {
                SECTION_TITLE: 'Total Royalties',
            },
        },
        TITLE: 'Reports',
    },
    SCRIPT_BLOCKER_WARNING: {
        BODY: {
            LINE_1: "We're having trouble making network requests through your browser.",
            LINE_2: 'This can happen if you are using a browser extension or antivirus software that is configured to block certain patterns, such as polling for data on a time interval.',
            LINE_3: {
                FALLBACK_URL: 'https://iq.trqk.io',
                PART_1: 'For the best experience, please add',
                PART_2: 'to your list of antivirus exceptions or disable your browser extension(s).',
            },
        },
        CLOSE: 'Close',
        SILENCE: 'Silence this warning',
        TITLE: 'Network requests are being blocked',
    },
    SELECT_CHART: 'Select chart:',
    SELECTED_STATEMENTS: 'Selected Statements',
    SIGN_IN: {
        BUTTONS: {
            FORGOT_PASSWORD: 'Forgot password?',
            SIGN_IN: 'Sign In',
        },
        CONFIRMED_EMAIL: 'Your account has been confirmed!',
        CTA: 'Sign in to your Trqk account',
        ERRORS: {
            BAD_CREDENTIALS: 'Invalid username or password',
        },
        SESSION_HAS_EXPIRED: 'Your session has expired.',
        SIGN_IN_TO_CONTINUE: 'Please sign in to continue.',
        USER_ALREADY_EXISTS:
            "It looks like you're trying to create an account with an email address that is already in use.",
        WELCOME_BACK: 'WELCOME BACK!',
    },
    SIGN_UP: {
        ALREADY_HAVE_AN_ACCOUNT: 'Already have an account?',
        BUTTONS: {
            CREATE_ACCOUNT: 'Create Account',
        },
        ERRORS: {
            REGISTER_INVITED_USER:
                'There was an error during user registration.',
        },
        SIGN_IN_HERE: 'Sign in here.',
        TITLE: 'Create an account',
        TOASTS: {
            INVITATION_REQUIRED: {
                DESCRIPTION:
                    "Trqk currently requires an invitation for new users. We've recorded your request to join, and will send you an email when it's approved.",
                EMAIL_CONTENT: {
                    BODY_PART_1:
                        'I need help with a trial invitation for the email address:',
                    BODY_PART_2: '[Enter any details you can provide here.]',
                    GREETING: 'Hello,',
                    SIGN_OFF: 'Thanks!',
                    SUBJECT: 'Help with Trqk invitation',
                },
                EMAIL_FOR_SUPPORT:
                    'If you think this is an error, please email us at',
                TITLE: 'Invitation required',
            },
        },
    },
    STANDARD_STATEMENTS: 'Domestic',
    STATEMENT_SELECTOR: {
        CLEAR_ALL: 'Clear All',
        LABELED_BY_DISTRIBUTION_PERIOD:
            'Statements are labeled by distribution period (two quarters after the performance period).',
    },
    STATEMENTS: {
        HEADER: {
            BUTTONS: {
                MANAGE_STATEMENTS: 'Manage Statements',
            },
            FALLBACK_STATEMENT_LABEL: 'Uploaded Statement',
        },
        INFO: {
            SMALL_VALUES_NOT_SHOWN: {
                PART_1: 'Values under',
                PART_2: 'are not shown.',
            },
            TOP_VALUES_SHOWN: {
                PART_1: 'Only the top',
                PART_2: 'values are shown.',
            },
        },
        KPIS: {
            ADJUSTMENTS: 'Adjustments',
            ASCAP_INTL_PERFORMANCES_INFO:
                'ASCAP international statements do not include performance counts.',
            BULK_PAYMENTS: 'Bulk Payments',
            CUE_SHEET: 'Cue Sheet',
            CUE_SHEET_PLURAL: 'Cue Sheets',
            EARNINGS: 'Earnings',
            MISC_BULK: 'Misc. Bulk',
            PERFORMANCE: 'Performance',
            PERFORMANCE_PLURAL: 'Performances',
            PROXIES: 'Proxies',
            SAMPLE_SURVEYS: 'Sample Surveys',
            SETTLEMENTS: 'Settlements',
            TRACK: 'Track',
            TRACK_PLURAL: 'Tracks',
        },
        PERFORMANCES: {
            BUTTONS: {
                ADVANCED_SEARCH: 'Advanced Search',
                CLEAR_FILTERS: 'Clear Filters',
            },
            ERRORS: {
                FETCH_PERFORMANCE_DATA:
                    'Encountered errors when fetching performance data for statement IDs: ',
            },
            FILTERS: {
                COUNTRY_CODE: {
                    ALL: 'All Territories',
                },
                DAY_PART: {
                    ALL: 'All Day Parts',
                },
                EARNINGS: {
                    ALL: 'All Earnings',
                    APPLY: 'Apply',
                    CANCEL: 'Cancel',
                    MAX: 'Max',
                    MIN: 'Min',
                    MODAL: {
                        TITLE: 'Earnings Range',
                    },
                },
                EPISODES: {
                    ALL: 'All Episodes',
                },
                MUSIC_USER_GENRE: {
                    ALL: 'All Media',
                },
                PAYMENT_TYPES: {
                    ALL: 'All Payment Types',
                },
                PROGRAMS: {
                    ALL: 'All Programs',
                },
                PUBLISHERS: {
                    ALL: 'All Publishers',
                },
                PUBLISHERS_AND_WRITERS: {
                    ALL: 'All Publishers/Writers',
                },
                SHOWS: {
                    ALL: 'All Programs',
                },
                SOURCES: {
                    ALL: 'All Channels',
                },
                USE_CODE: {
                    ALL: 'All Use Codes',
                },
                WORK_TITLES: {
                    ALL: 'All Work Titles',
                },
                WRITERS: {
                    ALL: 'All Writers',
                },
            },
            NO_PERFORMANCE_DATA:
                'There is no performance data for the current statement and / or filter selection.',
            SECONDARY_FILTERS: {
                APPLY: 'Apply',
                CANCEL: 'Cancel',
                TITLE: 'More Filters',
            },
            TITLE: 'Performance Data',
        },
        SECTIONS: {
            BREAKDOWN: {
                CONTENT_TITLE: 'Earnings Breakdown',
                FILTER_BY_MEDIA: 'by Media',
                FILTER_BY_PROGRAM: 'by Program',
                SECTION_TITLE: 'Breakdown',
            },
            EARNINGS_AND_RANGES: {
                DOLLARS_PER_PLAY: '$ / performance',
                DOLLARS_PER_SECOND: '$ / second',
                MEDIA_CONTRIBUTIONS: 'Media Contributions',
                OWNERSHIP_SHARES: 'Ownership Shares',
                PAYOUT_RANGES_PER_PERFORMANCE:
                    'Channel Payout Ranges ($ per Performance)',
                PAYOUT_RANGES_PER_SECOND:
                    'Channel Payout Ranges ($ per Second)',
                SECTION_TITLE: 'Earnings & Ranges',
                TRACK_EARNINGS: 'Track Earnings',
            },
            EXPLORER: {
                SECTION_TITLE: 'Explorer',
            },
            REGIONS: {
                CONTENT_TITLE: 'Earning Regions',
                SECTION_TITLE: 'Regions',
            },
        },
        SHOULD_SELECT_STATEMENTS: {
            SELECT_A_STATEMENT:
                'Select one or more statements to view your data',
            TITLE: 'Select statements to continue',
        },
        SHOULD_UPLOAD_STATEMENTS: {
            ADD_A_STATEMENT_TO_GET_STARTED: 'Add a statement to get started',
            HERE: 'here',
            UPLOAD_STATEMENTS: 'Upload your PRO statements',
        },
        TITLE: 'Statements',
    },
    STATEMENTS_PREVIEW: {
        MODALS: {
            REQUEST_INVITATION: {
                BUTTONS: {
                    CANCEL: 'Cancel',
                    REQUEST: 'Request',
                    SIGN_UP: 'Sign Up',
                },
                COMPANY: 'Company',
                CONFIRMATIONS: {
                    REQUEST_AN_INVITATION:
                        'Your request has been submitted. Please check your email for details.',
                },
                CREATE_AN_ACCOUNT: 'Create an Account',
                EMAIL: 'Email Address',
                ERRORS: {
                    REQUEST_AN_INVITATION:
                        'There was an error with your invitation request.',
                },
                INVITATION_CONFIRMED: 'Your invitation has been confirmed.',
                NAME: 'Name',
                PASSWORD: 'Password',
                REQUEST_AN_INVITATION: 'Request an Invitation',
            },
        },
        REQUEST_INVITATION_TAB: {
            ALREADY_HAVE_AN_ACCOUNT: 'Already have an account?',
            ALREADY_HAVE_AN_INVITATION: 'I already have an invitation.',
            BUTTONS: {
                REQUEST: 'Request',
            },
            DESCRIPTION:
                'Request a 14-day trial to explore your data in high resolution.',
            HEADER: 'Trqk has even more insights about your performances!',
            INVITATION_FOUND:
                "It looks like you've already been invited to join Trqk. Please add your info here to create an account.",
            SIGN_IN: 'Sign in',
        },
    },
    SUPPORTED_PROS: 'Trqk currently supports statements from',
    TOASTS: {
        ADDED_WRONG_FILE_TYPE: {
            FILE: 'a file that is',
            FILES: 'files that are',
            PART_1: 'You added',
            PART_2: 'not supported.',
            PART_3: 'Please select only',
            UPLOAD_ISSUE: 'Upload Issue',
        },
        CONFIRM_GAP_ANALYSIS_DELETION: {
            BUTTONS: {
                CANCEL: 'Cancel',
                DELETE: 'Delete',
            },
            ERROR: 'There was an problem when deleting your gap analysis report.',
            PART_1: 'You are about to delete the gap analysis report named:',
            PART_1_GENERIC: 'You are about to delete a gap analysis report.',
            PART_2: 'This cannot be undone.',
            SUCCESS: 'Your gap analysis report has been deleted.',
        },
        DETECTION_DOWNLOAD_READY: {
            DEFAULT_REPORT_NAME: 'Detection_Data',
            DOWNLOAD_REPORT: 'Download Detections',
            REPORT_IS_READY: 'Your detection download is ready.',
        },
        GAP_ANALYSIS_DOWNLOAD_READY: {
            DEFAULT_REPORT_NAME: 'Gap_Analysis_Report',
            DOWNLOAD_REPORT: 'Download Report',
            REPORT_IS_READY: 'Your gap analysis report is ready.',
        },
        SOME_UPLOADS_FAILED: {
            ERROR_MESSAGE: 'Error message:',
            FAILED: 'failed',
            INFO_FOR: 'Info for',
            OF_YOUR: 'of your',
            THERE_WAS_A_PROBLEM: 'There was a problem with',
            UPLOAD: 'upload',
            UPLOAD_ISSUE: 'Upload Issue',
            UPLOADS: 'uploads',
            YOUR: 'your',
        },
    },
    TRACK_DETAIL: {
        EMPTY_STATE: {
            CHANGE_SELECTION_1:
                'There is no performance data for the currently selected statement(s).',
            CHANGE_SELECTION_2:
                'To see performance data, please change your statement selection.',
            NO_PERFORMANCE_DATA:
                'There is no performance data for the current track.',
            SEE_DETECTIONS_1: 'You will see detection data if you',
            SEE_DETECTIONS_2: 'turn on detection',
            SEE_DETECTIONS_3: 'for this track.',
            SEE_PERFORMANCES_1: 'You will see performances if you',
            SEE_PERFORMANCES_2: 'match this audio file',
            SEE_PERFORMANCES_3: 'to a track from a statement.',
        },
        LOADING_ERROR: {
            DESCRIPTION:
                'We were unable to load this track. You will be sent to the previous page momentarily.',
            TITLE: 'Data loading error',
        },
        PERFORMANCE_CHART_LABELS: {
            SHOW_EARNINGS: 'Earnings by Program',
            SOURCE_EARNINGS: 'Earnings Share by Source',
            SOURCE_PLAYS: 'Plays by Source',
        },
    },
    TRACK_MATCHING_UPDATE_ERROR:
        'There was a problem with your track matching update. Please try again.',
    TRACK_RENAME_ERROR: 'We were unable to rename the track. Please try again',
    TRYOUT: {
        DASHBOARD_IS_UNAVAILABLE:
            'There was a problem when rendering your statement. Please try uploading a different CSV file.',
    },
    UNFILTERED_STATEMENTS: 'All Statements',
    UNKNOWN: 'Unknown',
    UNKNOWN_ENTITY: 'Unknown Entity',
    UNKNOWN_PERIOD: 'Unknown Period',
    UNKNOWN_PRO: 'Unknown PRO',
    UNKNOWN_ROLE_TYPE: 'unknown',
    UNKNOWN_USER: 'Unknown User',
    UNMATCHED_TRACK_DELETE_CONFIRMATION: 'Your unmatched track was deleted.',
    UPLOAD_AUDIO: {
        DROP_TO_UPLOAD: 'Drop audio files to upload',
        TITLE: 'Upload Audio',
        TOASTS: {
            ALL_UPLOADS_SUCCEEDED: {
                CHECK_THEM_OUT: 'check them out',
                FINISHED: 'finished',
                GO: 'Go',
                GOOD_NEWS: 'Good news!',
                UPLOAD_HAS: 'audio upload has',
                UPLOADS_HAVE: 'audio uploads have',
                WHEN_READY: "when you're ready!",
                YOUR_AUDIO: 'Your',
            },
            AUDIO_FILE_TOO_LARGE: {
                BODY: {
                    PART_1: 'Trqk supports audio files up to',
                    PART_2: 'MB in size.',
                    PART_3: 'Please try again with a smaller file.',
                },
                WARNING: 'Warning',
            },
            CANCEL_UPLOAD_FAILURE:
                'We were not able to cancel your audio upload.',
            CANCEL_UPLOAD_SUCCESS: 'Your audio upload was canceled.',
            GENERAL_ERROR: {
                PART_1: 'There was an error during audio file upload.',
                PART_2: 'Please wait a few minutes and try your upload again.',
                REPORT_ISSUE: 'Report this issue to:',
                REPORT_ISSUE_EMAIL: {
                    BODY: {
                        GREETING: 'Hello,',
                        PART_1: "I'm experiencing an error during audio upload; details of the error are below.",
                        SIGN_OFF: 'Thanks!',
                    },
                    SUBJECT: 'Trqk audio upload error report',
                },
            },
            MAX_UPLOAD_BATCH_EXCEEDED: {
                PART_1: 'You can upload up to',
                PART_2: 'audio files at once.',
                PART_3: 'Please wait until some uploads have completed.',
            },
            MAX_UPLOADS_EXCEEDED: {
                PART_1: 'You can upload a total of',
                PART_2: 'audio files.',
                PART_3: 'You currently have',
                PART_4: 'remaining.',
                UPLOAD: 'upload',
                UPLOADS: 'uploads',
            },
            UPLOAD_ISSUE: 'Upload Issue',
        },
        UPLOAD_ERROR: 'Upload error',
    },
    USAGE_EXCEEDS_PLAN: {
        CTA: 'Update your payment plan to continue.',
        OUTGROWN_PLAN:
            'It looks like your royalties or detections have outgrown your payment plan.',
        THANKS: 'Thanks for using TrqkIQ™!',
        TITLE: 'Capacity Overage',
        UPDATE_PLAN: 'Update Plan',
    },
    USE_UPLOAD_STATEMENTS: {
        TOASTS: {
            SINGLE_UPLOADS_ONLY:
                'You may upload one file at a time. Please try again with a single statement.',
        },
    },
    USERNAME_EXISTS_ERROR: 'That email address is already taken.',
    UTILS: {
        ERRORS: {
            GET_ALL_TRQK_AUDIOS:
                'There was an error when fetching your audio data.',
            GET_ALL_TRQK_SONGS:
                'There was an error when fetching your song data.',
            GET_ALL_TUNESAT_DETECTIONS:
                'There was an error when fetching your detection data.',
        },
    },
    VIEW_ALL_ENTITIES: 'View All Entities',
    WORKS: {
        CURRENT_DATA_EMPTY: 'There are no works to display yet.',
        DATA_IS_BEING_BUILT:
            'Data is being built for this table, please wait...',
        DESCRIPTION: {
            PART_1: "These are the works we've identified from your statements.",
            PART_2: 'Click a work title to view its performance and payout data.',
        },
        DROP_TO_UPLOAD: 'Drop audio files to upload',
        ERRORS: {
            GET_TRQK_ENTITY:
                'There was an error when fetching your list of works.',
            LIST_TRQK_TABLE_ROWS:
                'There was an error when fetching more works.',
        },
        REFRESH_STATUS: {
            CHECKING_FOR_NEW_WORKS:
                "We're checking your statements for new works - this can take a few minutes.",
            WORK_LIST_UPDATED: 'Your work list was recently updated.',
            WORKS_BEING_CLEANED_UP:
                'Deleted statement works are being cleaned up - this can take a few minutes.',
        },
        TITLE: 'Works',
        WORK_TYPE_FILTER: {
            DESCRIPTION: 'Work Type:',
            LABELS: {
                ALL: 'All',
                CUE_SHEETS: 'Cue Sheets',
                TRACKS: 'Tracks',
            },
        },
    },
    YEAR_TO_DATE_STATEMENTS: 'Year to Date',
};
